import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

interface AppEmptyStateProps {
  title: string;
  message: string;
  icon?: IconDefinition;
  className?: string;
  compact?: boolean;
}

const AppEmptyState = ({ title, message, icon, className = "", compact = false }: AppEmptyStateProps): JSX.Element => {
  const classes = `app-empty-state${compact ? " app-empty-state--compact" : ""}${className ? ` ${className}` : ""}`;

  return (
    <div className={classes}>
      {icon && (
        <div className="app-empty-state__icon" aria-hidden="true">
          <FontAwesomeIcon icon={icon} />
        </div>
      )}
      <div className="app-empty-state__content">
        <h3 className="app-empty-state__title">{title}</h3>
        <p className="app-empty-state__message">{message}</p>
      </div>
    </div>
  );
};

export default AppEmptyState;
